
import Backbone from 'backbone'
import LayerModel from '../models/LayerModel'

class ElementCollection extends Backbone.Collection {
  
  model(attrs, options) {
    switch (attrs.type) {
      case 'Layer': return new LayerModel(attrs, options)
      default: return new Backbone.Model(attrs, options)
    }
  }
}

export default ElementCollection
